const appReducer = (state = {}, action) => {
	switch(action.type) {
		case 'SET_CURRENT_APP':
			return {...state, ...action.currentApp};
		default:
			return state
	}
};

export default appReducer;